if (!customElements.get('wls-testimonials')) {
    class WLSTestimonials extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                slider: 'js-wls-testimonials',
                slide: 'splide__slide',
                splideClass: 'splide',
            };

            this.elements = {
                slides: this.querySelectorAll(`.${this.classes.slide}`),
                slider: this.querySelector(`.${this.classes.slider}`)
            };

            document.addEventListener("DOMContentLoaded", this.initialize.bind(this));
        }

        initialize() {
            if (this) {
                this.initSlider(this.elements.slider);
            }
        }


        initSlider(slider) {
            const slideCount = this.elements.slides.length;
            const isMobile = window.innerWidth <= 1024;

            if (slideCount <= 1) {
                if (slider.splide) {
                    slider.splide.destroy();
                }

                slider.classList.remove(this.classes.splideClass);
                if (this.elements.slides.length > 0) {
                    this.elements.slides.forEach((slide) => {
                        slide.classList.remove(this.classes.splideSlideClass);
                    });
                }
            } else if (slideCount > 1) {
                const testamonialsSlider = new Splide(slider, {
                    perPage: 1,
                    perMove: 1,
                    type: "loop",
                    focus: "left",
                    pagination: true,
                    arrows: true,
                    gap: "1.6rem",
                    drag: true,
                    snap: isMobile,
                });

                if (slider.splide) {
                    slider.splide.destroy();
                }

                slider.splide = testamonialsSlider;
                testamonialsSlider.mount();
            }
        }
    }
    window.customElements.define('wls-testimonials', WLSTestimonials);
}

